interface ICindUserInStageCb{
	(item:any):boolean;
}
export interface Imap{
	layers:Array<Ilayer>;
	scale?:number;
}
import {IUserSession} from "../../../interfaces/layout/blocks/IUser";

export interface Ilayer extends IUserSession{
	x:number;
	y: number;
	properties:any;
	name: string;
	image: string;
	levelIndex: number;
	levelId:string;
    itemNumber:number;
	allBrothers: Array<number>;
	id_key: number; //for front family tree
	width: number; //for front family tree
	height: number; //for front family tree
}

import Ajax from "../../lib/Ajax";
export class Config {
    protected gui_objects: Array<any>;
    protected control_type: string;
    protected camera_move_mode: string;
    protected original_height: number;
    protected upLineHeight: number;
    protected verison: number;
    protected edit_mode: boolean;
    protected url: string;
    protected default_url: string;
	protected boxvVerticalDistance:number;
	protected boxvHorisontalDistance:number;
	protected boxWidth:number;
	protected map: Imap;
	protected ground: any;
	protected current_map: any;

	protected stage: createjs.Stage;
	protected preload: createjs.LoadQueue;
	protected canvas: HTMLCanvasElement;
	protected scale: number;
	protected addedIdsInStage:Array<number>;

	protected stageDragEnabled:boolean;
	protected stagePositons:any;
    protected userId:number;


    constructor(default_url:string, url:string) {
		this.current_map            = {};
		this.current_map.item       = {};
		this.scale                  = 1
		this.stageDragEnabled 	    = true;
		this.stagePositons		    = {
			x: 0,
			y: 0
		};
		this.addedIdsInStage        = [];
        this.userId                 = null;

        this.control_type           = 'oneClick';
        this.camera_move_mode       = 'default';
        this.original_height        = 800;
		this.upLineHeight           = 200;
		this.boxWidth               = 200;
        this.verison                = 1;
        this.edit_mode              = false;
        this.url                    = url;
        this.default_url            = default_url;
        this.boxvHorisontalDistance = 300; //200
		this.boxvVerticalDistance   = 300; //200
        // this.edit_mode           = true;

        this.gui_objects            = [];
    }

    public loadGui(cb: Function): void {
        var loaded_items = [];
		new Ajax(this.default_url, 'GET', null, (map:Imap) => {
			for (var key in map.layers) {
				var img = map.layers[key].image.toString();
				var item = map.layers[key];
				var t = { id: item.name, src: item.image.toString()/*.replace('..\/', '')*/ };
				if (loaded_items.indexOf(t.src) === -1) {
					this.gui_objects.push(t);
					loaded_items.push(t.src);
				}
			}
            if ( this.userId === null ) {
                this.getData(map, cb);
            }else{
                this.getData(map, cb, this.userId);
            }
		});
    }
    public getData(map:Imap, cb: Function, id?:number): void {
        var loaded_items = [];
		var postData:any = null;
		if ( id !== undefined ) {
			postData = {
				'id': id
			};
		}
		new Ajax(this.url, 'POST', postData, (saved_map) => {
			for (var key in saved_map.items) {
                var item = saved_map.items[key];
				var img  = item.img;
				item.levelIndex = null;
				item.levelId = null;
				item.itemNumber = null;
				if (item.properties !== undefined) {
					if (item.properties.type !== undefined) {
						if ( item.visible === true ) {
							console.log('ajax sarter level index', item);
							item.levelIndex = 0;
						}
					}
				}
				item.x = 0;
				item.y = 0;
				item.width = 0;
				item.height = 0;
				item.name = "profileImg_" + item.id;
				item.opacity = 1;
				item.origianl_item = true;
				item.properties = {
					move: "fixed",
					shape_name: "profileImg",
					type: "none"
				};
				item.type = "none";
				if ( item.img === '' ) {
					item.img = '/img/default.png';
					item.name = "profileImg";
				}
				if ( item.visible === true ) {
					item.center = true;
				}
				if ( item.brothersIds === null ) {
					item.brothersIds = [];
				}
				var all:Array<number> = item.brothersIds;
				if ( item.sistersIds !== null ) {
					all = all.concat(item.sistersIds);
				}
				if ( item.halfBloodIds !== null ) {
					all = all.concat(item.halfBloodIds);
				}
				item.allBrothers = all;
				var t = { id: item.name, src: item.img/*.replace('..\/', '')*/ };
				if (loaded_items.indexOf(t.src) === -1) {
					this.gui_objects.push(t);
					loaded_items.push(t.src);
				}
				map.layers.push(item);
			}
			if ( saved_map.scale !== undefined ) {
				map.scale = saved_map.scale;
			}
			cb(map);
		});
    }

	protected findUserInStage(id:number|Array<number>, cb:ICindUserInStageCb):void{
		if ( typeof id !== "number" ) {
			var ids:Array<number> = id;
			for (var key in ids) {
				var currentId = ids[key];
				if ( currentId > 0 ) {
					for (var key in  this.current_map.item) {
						var item =  this.current_map.item[key];
						if ( item.id_key !== undefined && item.id_key === currentId ) {
							 this.current_map.item[key] = cb(item);
							break;
						}
					}
				}
			}
		}else{
			if ( id > 0 ) {
				for (var key in  this.current_map.item) {
					var item =  this.current_map.item[key];
					if ( item.id_key !== undefined && item.id_key === id ) {
						 this.current_map.item[key] = cb(item);
						return;
					}
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./components/family_tree/Config.ts